import { Controller } from 'stimulus';

class NativeHorizontalScrollController extends Controller {
  connect() {
    this.list = this.element.querySelector('[data-target="horizontal-scroll.list"]');
    this.parentGrid = this.list.closest('.grid');

    if (!this.parentGrid) {
      return;
    }

    this.onWindowResizeBound = this.onWindowResize.bind(this);

    window.addEventListener('resize', this.onWindowResizeBound);

    this.calculateNativeSliderPosition();
  }

  disconnect() {
    window.removeEventListener('resize', this.onWindowResizeBound);
  }

  onWindowResize() {
    this.calculateNativeSliderPosition();
  }

  calculateNativeSliderPosition() {
    const parentGrid = this.list.closest('.grid');

    if (parentGrid) {
      const { left } = parentGrid.getBoundingClientRect();
      let { paddingLeft } = window.getComputedStyle(parentGrid);

      paddingLeft = parseInt(paddingLeft, 10);

      this.element.style.overflowX = 'auto';
      this.element.style.paddingLeft = `${left + paddingLeft}px`;
      this.element.style.paddingRight = `${left + paddingLeft}px`;
      this.element.style.marginLeft = `${(left + paddingLeft) * -1}px`;
      this.element.style.marginRight = `${(left + paddingLeft) * -1}px`;
    }
  }
}

NativeHorizontalScrollController.targets = [
  //
];

export default NativeHorizontalScrollController;
